// === configSlice enums ```
export enum CONFIG_FEATURE_FLAG {
  IS_DRAGONSTONE = "IS_DRAGONSTONE",
  IS_ELIGIBLE_TO_SHOW_GRATITUDE_COMPONENT = "IS_ELIGIBLE_TO_SHOW_GRATITUDE_COMPONENT",
  IS_CUSTOMER_SERVICE_JOB = "IS_CUSTOMER_SERVICE_JOB",
  IS_UK_RTW_NO_CAAS_INTEGRATION = "IS_UK_RTW_NO_CAAS_INTEGRATION",
  IS_ELIGIBLE_FOR_CSS = "IS_UK_RTW_NO_CAAS_INTEGRATION",
  IS_ELIGIBLE_FOR_APPOINTMENT_RESCHEDULING = "IS_ELIGIBLE_FOR_APPOINTMENT_RESCHEDULING",
}

export enum CONFIG_DATA {
  GRATITUDE_COMPONENT_STATE = "GRATITUDE_COMPONENT_STATE",
  RTW_TASK_DEFINITION = "RTW_TASK_DEFINITION",
  CANDIDATE_DATA = "CANDIDATE_DATA",
}

export type CONFIG_KEYS = CONFIG_FEATURE_FLAG | CONFIG_DATA;

export enum DOC_UPLOAD_PAGE_STATE {
  SELECT_DOCUMENT_TYPE = "SELECT_DOCUMENT_TYPE",
  SELECT_FILE_TO_UPLOAD = "SELECT_FILE_TO_UPLOAD",
}

export enum DOC_UPLOAD_FORM_INPUT_IDS {
  SELECT_DOCUMENT_CATEGORY = "SELECT_DOCUMENT_CATEGORY",
  SELECT_DOCUMENT_ITEM = "SELECT_DOCUMENT_ITEM",
}

export enum DOC_UPLOAD_CATEGORIES {
  MANDATORY = "MANDATORY",
  NON_MANDATORY = "NON_MANDATORY",
}

export enum DOC_UPLOAD_REQUIRED_PAGES {
  FRONT = "Front",
  BACK = "Back",
}

export enum DOC_UPLOAD_ITEM_WIDGET_VALID_STATE {
  PROCESSING = "PROCESSING",
  SUCCESSFUL = "SUCCESSFUL",
}

export enum DOC_UPLOAD_ITEM_WIDGET_NON_VALID_STATE {
  FAILED_UPLOAD = "FAILED_UPLOAD",
  SIZE_EXCEEDED = "SIZE_EXCEEDED",
  NOT_SUPPORTED_FORMAT = "NOT_SUPPORTED_FORMAT",
}

export type DOC_UPLOAD_ITEM_WIDGET_STATE = DOC_UPLOAD_ITEM_WIDGET_VALID_STATE | DOC_UPLOAD_ITEM_WIDGET_NON_VALID_STATE;

export enum DOC_VALID_FORMAT {
  JPEG = "JPEG",
  JPG = "JPG",
  PDF = "PDF",
  PNG = "PNG",
}

export enum EDM_UPLOAD_STATUS {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
}

export enum EDM_REVIEW_STATUS {
  APPROVED = "Approved",
  APPROVED_MANUALLY_UPLOADED = "Approved Manually Uploaded",
  REJECTED = "Rejected",
  REJECT_MANUALLY_UPLOADED = "Reject Manually Uploaded",
}

export enum EDM_DOC_TYPE {
  PASSPORT = "PASSPORT",
  BIRTH_CERTIFICATE = "BIRTH_CERTIFICATE",
  DRIVERS_LICENSE = "DRIVERS_LICENSE",
  LICENSES_AND_CERTIFICATES = "LICENSES_AND_CERTIFICATES",
  PHOTO_ID = "PHOTO_ID",
}
